import BaseAPI from './base.api';
import {
  type GradeCategoryRecord,
  type GradeCategoryPayload,
} from 'views/DispatchImporters/CategoryManagement/types';

export default class GradeCategoryAPI extends BaseAPI {
  getAll = async (): Promise<GradeCategoryRecord[]> => {
    const response = await this.API.get('grade-category', {
      params: { customerId: this.customerId },
    });
    return Array.isArray(response.data) ? response.data : [];
  };

  create = async (
    payload: GradeCategoryPayload
  ): Promise<GradeCategoryRecord> => {
    const response = await this.API.post('grade-category', payload, {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  update = async (
    gradeCategory: string,
    payload: Partial<Pick<GradeCategoryPayload, 'minGrade' | 'maxGrade'>>
  ): Promise<GradeCategoryRecord> => {
    const response = await this.API.put(
      `grade-category/${encodeURIComponent(gradeCategory)}`,
      payload,
      { params: { customerId: this.customerId } }
    );
    return response.data;
  };

  remove = async (gradeCategory: string): Promise<void> => {
    await this.API.delete(
      `grade-category/${encodeURIComponent(gradeCategory)}`,
      { params: { customerId: this.customerId } }
    );
  };
}
